import { render, staticRenderFns } from "./allestimento.vue?vue&type=template&id=27d0eff3&"
import script from "./allestimento.vue?vue&type=script&lang=js&"
export * from "./allestimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports